import { TranslatedText } from '@sms/plasma-ui';
import React, { FC } from 'react';

import { IProps } from '../index';

export const DecimalClassRow: FC<IProps> = ({ statistics }) => {
  return (
    <>
      {statistics && 'sepDecimalClass' in statistics && (
        <li className="seg__statistics__item">
          <p>
            <TranslatedText textKey="side-menu.class-decimal" />
          </p>
          <p>{statistics.sepDecimalClass}</p>
        </li>
      )}
    </>
  );
};
